import { FlagTriangleIcon } from './FlagTriangleIcon';

/**
 * author: Austin Andrews
 * id 3E14D0C4-25AA-405E-89A7-37E9A224BA93
 * name flag-triangle
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/flag-triangle.svg
 * tags
 */
export const MilestoneIcon = FlagTriangleIcon;
export default MilestoneIcon